import { bff, createBFFHandlers } from '~/framework/bff';
import { z } from 'zod';
import { getServerSideMonolithClient } from '~/framework';
import { getGuide as getGuideFromMonolith, GetGuideRequestOption } from '~/monolith-api/guides';
import { CommonRequestOptions } from '~/monolith-api/makeRequest';

const getGuideSchema = z.object({
   guideid: z.number(),
   unpatrolled: z.boolean().optional(),
   releaseid: z.number().nullable().optional(),
   useSourceLang: z.boolean().optional(),
   includeComments: z.boolean().optional(),
});

export async function getGuide(
   guideid: number,
   options: GetGuideRequestOption,
   commonOptions: CommonRequestOptions
) {
   return await getGuideFromMonolith(guideid, {
      ...options,
      ...commonOptions,
   });
}

export default createBFFHandlers({
   post: async (req, res) => {
      const { guideid, ...options } = getGuideSchema.parse(req.body);
      const monolithClient = getServerSideMonolithClient(req);
      const result = await getGuide(guideid, options, {
         apiClient: monolithClient,
      });
      res.status(200).json(result);
   },
});

export const getGuideFromClient = (
   guideid: number,
   options: GetGuideRequestOption = {}
): ReturnType<typeof getGuide> => {
   return bff()
      .post('/guides/getGuide', {
         guideid,
         ...options,
      })
      .then(response => response.data);
};

export type GetGuideErrorCode = 'guides.guide_not_found';
